import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Dropdown, Icon, Input, Menu, Modal, message, Table, Tag, Typography } from "antd";

import moment from "moment";

import { suggestionService } from "./../../redux/services";

import DefaultTemplate from "./../../templates/defaultTemplate";

import ModalAnswer from "./answer";
import ModalShow from "./show";
import ModalExport from "./export";
import UserModalShow from "./../Customers/show";

const config = {
	title               : "Sugestões",
	orderByField        : "created_at",
	orderBySort         : "desc",
	permissionPrefix    : "suggestions",
	userPermissionPrefix: "users",
};

class Index extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoading           : false,
			data                : [],
			pagination          : {
				current : 1,
				pageSize: 15,
				total   : 0,
			},
			orderByField        : config.orderByField,
			orderBySort         : config.orderBySort,
			search              : "",
			// Actions
			answerModalVisible  : false,
			showModalVisible    : false,
			exportModalVisible  : false,
			// Users
			userShowModalVisible: false,
		};
	}

	componentDidMount() {
		// Fecth all
		this.fetchGetAll();
	}

	menuMain = () => (
		<Menu className="actions-dropdown-menu">
			{this.props.permissions.includes(config.permissionPrefix + ".export") && <Menu.Item key="export">
				<a onClick={this.exportOpen}>
					<Icon type="export" />Exportar
				</a>
			</Menu.Item>}
		</Menu>
	);

	menu = (item) => (
		<Menu className="actions-dropdown-menu">
			{this.props.permissions.includes(config.permissionPrefix + ".show") && <Menu.Item key="show">
				<a onClick={() => this.showOpen(item)}>
					<Icon type="file-text" />Visualizar
				</a>
			</Menu.Item>}
			{!item.is_answered && this.props.permissions.includes(config.permissionPrefix + ".answer") && <Menu.Item key="answer">
				<a onClick={() => this.answerOpen(item)}>
					<Icon type="message" />Responder
				</a>
			</Menu.Item>}
			{item.is_answered && this.props.permissions.includes(config.permissionPrefix + ".answer") && <Menu.Item key="resend_answer">
				<a onClick={() => this.resendAnswerConfirm(item)}>
					<Icon type="mail" />Reenviar resposta
				</a>
			</Menu.Item>}
			{this.props.permissions.includes(config.permissionPrefix + ".delete") && <Menu.Item key="delete">
				<a onClick={() => this.deleteConfirm(item)}>
					<Icon type="delete" />Excluir
				</a>
			</Menu.Item>}
		</Menu>
	);

	columns = () => {
		let columns = [
			{
				title    : "ID",
				key      : "id",
				dataIndex: "id",
				width    : 90,
				sorter   : true,
				fixed    : "left",
			},
			{
				title    : "Usuário",
				key      : "user.name",
				dataIndex: "user.name",
				width    : 200,
				sorter   : true,
				render   : (text, item) => (
					this.props.permissions.includes(config.userPermissionPrefix + ".show") ? <a onClick={() => this.userShowOpen(item.user)}>
						{text}
					</a> : text
				),
			},
			{
				title    : "Respondido",
				key      : "is_answered",
				dataIndex: "is_answered",
				width    : 120,
				sorter   : true,
				render   : (text, item) => <Tag color={text ? "#26B47F" : "#ED4B48"}>{text ? "Sim" : "Não"}</Tag>
			},
			{
				title    : "Mensagem",
				key      : "message",
				dataIndex: "message",
				sorter   : true,
			},
			{
				title    : "Respondido em",
				key      : "answered_at",
				dataIndex: "answered_at",
				width    : 160,
				sorter   : true,
				render   : (text) => text ? moment(text).format("DD/MM/YYYY HH:mm") : null,
			},
			{
				title           : "Criação",
				key             : "created_at",
				dataIndex       : "created_at",
				width           : 150,
				sorter          : true,
				defaultSortOrder: "descend",
				render          : (text) => moment(text).format("DD/MM/YYYY HH:mm"),
			},
			{
				title    : "Últ. modificação",
				key      : "updated_at",
				dataIndex: "updated_at",
				width    : 160,
				sorter   : true,
				fixed    : window.innerWidth > 991 ? "right" : false,
				render   : (text) => moment(text).format("DD/MM/YYYY HH:mm"),
			},
		];

		if( this.props.permissions.includes(config.permissionPrefix + ".show") || this.props.permissions.includes(config.permissionPrefix + ".answer") || this.props.permissions.includes(config.permissionPrefix + ".delete") )
		{
			columns.push({
				title    : "Ações",
				key      : "actions",
				width    : 78,
				className: "actions disable-sort",
				fixed    : window.innerWidth > 767 ? "right" : false,
				render   : (text, item) => (
					<Dropdown overlay={this.menu(item)} className="actions-dropdown" placement="bottomRight" trigger={["click"]}>
						<Button icon="more" />
					</Dropdown>
				),
			});
		}

		return columns;
	};

	fetchGetAll = () => {
		const {pagination, orderByField, orderBySort, search} = this.state;

		this.setState({
			isLoading: true,
		});

		suggestionService.getAll({
			page   : pagination.current,
			limit  : pagination.pageSize,
			orderBy: `${orderByField},${orderBySort}`,
			search : search,
		})
		.then((response) => {
			this.setState(state => ({
				isLoading : false,
				data      : response.data.data,
				pagination: {
					...state.pagination,
					total: response.data.meta.total,
				},
			}));
		})
		.catch((data) => {
			this.setState({
				isLoading: false,
			});

			Modal.error({
				title  : "Ocorreu um erro!",
				content: data.error_message,
			});
		});
	};

	handleTableChange = (pagination, filters, sorter) => {
		this.setState(state => ({
			pagination  : {
				...state.pagination,
				current : pagination.current,
				pageSize: pagination.pageSize,
			},
			orderByField: sorter.field ? sorter.field : config.orderByField,
			orderBySort : sorter.order === "descend" ? "desc" : "asc",
		}), () => {
			this.fetchGetAll();
		});
	};

	onSearch = (value) => {
		this.setState({
			search: value,
		}, () => {
			this.fetchGetAll();
		});
	};

	onSearchChange = (e) => {
		// If it does not have type then it's cleaning
		if( !e["type"] )
		{
			const {search} = this.state;

			this.setState({
				search: e.target.value,
			}, () => {
				if( search )
				{
					this.fetchGetAll();
				}
			});
		}
	};

	/**
	 * Show
	 *
	 * @param id
	 */
	showOpen = ({id}) => {
		this.setState({showModalVisible: true});

		// On open screen
		this.showScreen.onOpen(id);
	};

	showOnClose = () => {
		this.setState({showModalVisible: false});
	};

	/**
	 * Answer
	 *
	 * @param id
	 */
	answerOpen = ({id}) => {
		this.setState({answerModalVisible: true});

		// On open screen
		this.answerScreen.onOpen(id);
	};

	answerOnClose = () => {
		this.setState({answerModalVisible: false});
	};

	answerOnComplete = () => {
		this.setState({answerModalVisible: false});

		// Fecth all
		this.fetchGetAll();
	};

	/**
	 * Delete
	 *
	 * @param id
	 */
	deleteConfirm = ({id}) => {
		Modal.confirm({
			title  : "Confirmar exclusão!",
			content: "Tem certeza de que deseja excluir este registro?",
			okText : "Excluir",
			onOk   : () => {
				return this.deleteConfirmed(id);
			}
		});
	};

	deleteConfirmed = (id) => {
		return suggestionService.destroy({id})
		.then((response) => {
			// Fecth all
			this.fetchGetAll();
		})
		.catch((data) => {
			Modal.error({
				title  : "Ocorreu um erro!",
				content: data.error_message,
			});
		});
	};

	/**
	 * Export
	 */
	exportOpen = () => {
		this.setState({exportModalVisible: true});
	};

	exportOnClose = () => {
		this.setState({exportModalVisible: false});
	};

	exportOnComplete = () => {
		this.setState({exportModalVisible: false});
	};

	/**
	 * Show user
	 *
	 * @param id
	 */
	userShowOpen = ({id}) => {
		this.setState({userShowModalVisible: true});

		// On open screen
		this.userShowScreen.onOpen(id);
	};

	userShowOnClose = () => {
		this.setState({userShowModalVisible: false});
	};

	/**
	 * Resend answer
	 *
	 * @param id
	 */
	resendAnswerConfirm = ({id}) => {
		Modal.confirm({
			title  : "Confirmar reenvio!",
			content: "Tem certeza de que deseja reenviar o e-mail da resposta ao usuário?",
			okText : "Reenviar",
			onOk   : () => {
				return this.resendAnswerConfirmed(id);
			}
		});
	};

	resendAnswerConfirmed = (id) => {
		return suggestionService.resendAnswer({id})
		.then((response) => {
			// Success message
			message.success("Resposta reenviada com sucesso.");
		})
		.catch((data) => {
			Modal.error({
				title  : "Ocorreu um erro!",
				content: data.error_message,
			});
		});
	};

	render() {
		return (
			<DefaultTemplate>
				<div className="page-content" key="1">
					<h1 className="page-title">{config.title}</h1>
					<div className="page-listing-header">
						<div className="search">
							<Input.Search
								placeholder="Pesquisar"
								onSearch={this.onSearch}
								onChange={this.onSearchChange}
								enterButton
								allowClear
							/>
						</div>
						{this.props.permissions.includes(config.permissionPrefix + ".export") && (
							<div className="actions">
								<Dropdown className="actions-dropdown" placement="bottomRight" trigger={["click"]} overlay={this.menuMain}>
									<Button type="primary" icon="more" />
								</Dropdown>
							</div>
						)}
					</div>
					{this.state.search && <Typography.Paragraph>Buscando por <Typography.Text mark>{this.state.search}</Typography.Text></Typography.Paragraph>}
					<Table
						className="page-listing-body"
						columns={this.columns()}
						rowKey="id"
						bordered
						scroll={{x: 1600}}
						dataSource={this.state.data}
						pagination={{...this.state.pagination, showSizeChanger: false, showQuickJumper: false, hideOnSinglePage: true}}
						loading={this.state.isLoading}
						onChange={this.handleTableChange}
						footer={() => `Total ${this.state.pagination.total} de registros encontrados.`}
					/>
				</div>
				<ModalAnswer
					wrappedComponentRef={el => this.answerScreen = el}
					visible={this.state.answerModalVisible}
					onComplete={this.answerOnComplete}
					onClose={this.answerOnClose}
				/>
				<ModalShow
					ref={el => this.showScreen = el}
					visible={this.state.showModalVisible}
					onClose={this.showOnClose}
				/>
				<ModalExport
					visible={this.state.exportModalVisible}
					onComplete={this.exportOnComplete}
					onClose={this.exportOnClose}
				/>
				<UserModalShow
					ref={el => this.userShowScreen = el}
					visible={this.state.userShowModalVisible}
					onClose={this.userShowOnClose}
					external={true}
				/>
			</DefaultTemplate>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		permissions: state.auth.userData.permissions,
	};
};

export default connect(mapStateToProps)(Index);
